module.exports = __webpack_public_path__ + "static/media/orgStructure.c6c87ba1.png";